import { PublicKey } from '@solana/web3.js';
import posthog from 'posthog-js';
import { MarketId, ServerAuctionParamsResponse } from '@drift/common';
import useMarketStateStore from 'src/stores/useMarketStateStore';

// Intentionally reads from store for diagnostics — logs store state at order time
export const logOrderParams = (
	marketId: MarketId,
	userAccountPubKey: PublicKey,
	urlParams: URLSearchParams,
	response: ServerAuctionParamsResponse
) => {
	const marketState = useMarketStateStore
		.getState()
		.getMarketDataForMarket(marketId);

	// TODO: move to react query
	const mmOraclePrice = marketState?.mmOracle?.price?.print();
	const regularOraclePrice = marketState?.oracle?.price?.print();
	const oraclePrice = mmOraclePrice || regularOraclePrice;

	const urlParamsObject: Record<string, string> = {};
	urlParams.forEach((value, key) => {
		urlParamsObject[key] = value;
	});

	posthog.capture('order_params_request', {
		user_account_pubkey: userAccountPubKey,
		url_params: urlParamsObject,
		oracle_price: oraclePrice,
		mm_oracle_price: mmOraclePrice,
		regular_oracle_price: regularOraclePrice,
		derived_market_state: marketState?.derivedState
			? {
					mark_price: marketState.derivedState.markPrice.print(),
					best_bid: marketState.derivedState.bestBid.print(),
					best_ask: marketState.derivedState.bestAsk.print(),
					update_slot: marketState.derivedState.updateSlot,
				}
			: undefined,
		endpointResponse: response,
	});
};
